// src/locales/en.js

const en = {
  // --- Common / Global ---
  common_loading: "Loading...",
  common_error_generic: "An error occurred. Please try again.",
  common_previous: "Previous",
  common_next: "Next",
  common_page: "Page",
  common_of: "of",
  common_site_title: "Astronomyshare.com",
  common_back_to_login: "Back to Login", 
  error_auth_token_required: "Auth Token Required",

  // --- Banner ---
  banner_logo_alt: "Astronomy Banner",

  // --- Navigation ---
  nav_home: "Home",
  nav_browse: "Browse",
  nav_upload: "Upload",
  nav_terms: "Terms of Use",
  nav_privacy: "Privacy Policy",
  nav_settings: "User Settings", 
  nav_login: "Log In", 
  nav_register: "Register", 
  nav_logout: "Logout", 

  // --- Footer ---
  footer_extras: "Other Foolishness", 

  // --- Homepage ---
  homepage_short_welcome: 'Welcome to AstronomyShare.com',
  homepage_paragraph_one:
    'This platform is dedicated to revolutionizing the way we capture the cosmos. Our goal is to provide a space where enthusiasts and professionals alike can share their raw data—called subs—allowing others to integrate hundreds or even thousands of hours of exposure time into their projects, instead of just tens. By pooling resources and combining efforts, we can achieve stunning, high-quality images of the night sky, pushing the boundaries of what\'s possible in astrophotography. Join us in this collaborative effort to explore the universe in greater detail than ever before!',
  homepage_paragraph_two:
    'astronomyshare.com is privately funded and committed to keeping the platform accessible. We aim to offer this service for free (test) until we reach a certain size, after which there will be a modest cost to help cover the growing operational expenses. Our goal is to create a sustainable and thriving community that continues to foster collaboration and innovation in astrophotography for years to come.', // Removed dev joke

  // --- Homepage (Logged in)---
  home_title: "Welcome Home",
  home_welcome: "Welcome to AstronomyShare.com",
  home_loading_image_count: "image count?",
  home_image_count_prefix: "This site is currently hosting ",
  home_image_count_suffix: "images.",

  // --- Terms of Use ---
  terms_title: 'Terms of Use', 

  // --- Privacy Policy ---
  privacy_policy_title: 'Privacy Policy', 

  // --- Authentication Pages (Login, Register, Forgot, Reset) ---
  auth_login_title: 'Login',
  auth_login_username_label: 'Username', 
  auth_login_password_label: 'Password',
  auth_login_submit_button: 'Login',
  auth_login_loading_button: 'Logging in...',
  auth_login_no_account_prompt: "Don't have an account?",
  auth_login_register_link: "Register Here",
  auth_login_forgot_password_link: "Forgot Password?",
  auth_login_verified_message: "Email successfully verified! Please log in.", 
  auth_login_reset_success_message: "Password reset successfully! You can now log in.", 
  auth_login_username_hint: "Username only, Email not accepted",

  auth_register_title: "Register",
  auth_register_username_label: "Username",
  auth_register_email_label: "Email",
  auth_register_password_label: "Password",
  auth_register_confirm_password_label: "Confirm Password",
  auth_register_loading_button: "Registering...",
  auth_register_submit_button: "Register",
  auth_register_already_account_prompt: "Already have an account?",
  auth_register_login_link: "Log in here",
  auth_register_password_hint: "Password must be 8 characters long",

  auth_forgot_password_title: "Reset Your Password", 
  auth_forgot_password_instructions: "Enter the email address associated with your account. If an account exists, we will send a link to reset your password.", 
  auth_forgot_password_email_label: "Email Address", 
  auth_forgot_password_submit_button: "Send Reset Link", 
  auth_forgot_password_loading_button: "Sending...", 
  auth_forgot_password_back_link: "Back to Login", 
  auth_forgot_password_button: "Send Reset Link",


  auth_reset_password_title: "Set New Password", 
  auth_reset_password_new_label: "New Password", 
  auth_reset_password_confirm_label: "Confirm New Password", 
  auth_reset_password_submit_button: "Reset Password", 
  auth_reset_password_loading_button: "Resetting...", 

  // --- Browse Page ---
  browse_title: "Browse and download images below", 
  browse_filter_title: "Narrow your search:", 
  browse_filter_focal_length_label: "Focal Length:", 
  browse_filter_target_label: "Target:", 
  browse_no_images_message: "No images match your selected criteria", 
  browse_pagination_page: "Page", 
  browse_pagination_of: "of", 
  browse_images_found_text: "image(s) found", 
  browse_prev_button: "Previous", 
  browse_next_button: "Next", 
  browse_download_button: "Download",
  browse_delete_button: "Delete",
  delete_confirm_prompt: "Are you sure you want to delete this file?",
  browse_target_fetch_error: "Error fetching targets!",
  browse_images_loading: "Loading Images",
  browse_apply_filters_button: "Apply Filters",
  browse_error_download_url_missing: "Download URL Missing",
  browse_filter_target_placeholder: "e.g., M31",
  browse_filter_focal_length_placeholder: "e.g., 1000",

  // --- Upload Page ---
  upload_title: "Upload Image/Data", 
  upload_loading_user: "Loading user info...", 
  upload_loading_targets: "Loading targets...", 
  upload_target_error_prefix: "Error loading targets:", 
  upload_no_files_selected_error: "Please select files to upload.", 
  upload_not_logged_in_error: "User information not available. Please log in again.", 
  upload_target_required_error: "Please select or enter a target name.", 
  upload_metadata_title: "Image Metadata (Applies to all selected files)", 
  upload_target_label: "Target:", 
  upload_target_select_placeholder: "Select existing or type to create...", 
  upload_focal_length_label: "Focal Length (mm):", 
  upload_exposure_time_label: "Exposure Time (s):", 
  upload_filter_used_label: "Filter Used:", 
  upload_select_files_label: "Select Files:", 
  upload_submit_button: "Upload Selected Files", 
  upload_loading_button: "Uploading...", 
  upload_progress_title: "Upload Status", 
  upload_overall_progress_label: "Overall Batch Progress",
  upload_summary_title: "Upload Summary", 
  upload_status_uploading: "Uploading file {{current}} of {{total}}{{filename_part}} - {{progress}}%",
  upload_status_success: "Uploaded file {{current}} of {{total}}{{filename_part}}",
  upload_status_error: "Error uploading file {{current}} of {{total}}{{filename_part}}: {{error}}", 
  upload_status_pending: "Preparing file {{current}} of {{total}}{{filename_part}}...",
  upload_status_error_default: "Failed", 
  upload_error_s3_failed: "'S3 upload failed",
  upload_error_invalid_file_type_selected: "Invalid file type(s) selected: {{invalidNames}}. Allowed types: FITS, XISF, JPG, PNG, TIFF.",
  API_UPLOAD_CONFIRM_INVALID_SIZE: "Invalid file size received in confirmation.",
  API_UPLOAD_CONFIRM_QUOTA_EXCEEDED: "Upload Failed: Storage quota exceeded",

  // Download
  download_error_missing_key_local: "Download Error: Missing Key",

  // Auth Success (Backend Return or Frontend Trigger)
  API_AUTH_REGISTRATION_SUCCESS_VERIFY_EMAIL: 'Registration successful! Please check your email for a verification link.', 
  API_AUTH_REGISTRATION_FAILED: "Registration Failed, please try again later",
  API_AUTH_VERIFICATION_SUCCESS: 'Email successfully verified! Please log in.', 
  API_AUTH_PASSWORD_RESET_SUCCESS: 'Password has been reset successfully! You can now log in.', 
  API_AUTH_LOGIN_SUCCESS: 'Login successful! Redirecting...', 
  API_AUTH_LOGIN_NO_TOKEN: "Login failed: Authentication incomplete. Please try again.",

  // Auth Errors (Returned by Backend)
  API_AUTH_MISSING_FIELDS: 'All required fields must be filled.',
  API_AUTH_INVALID_EMAIL_FORMAT: 'Please enter a valid email format.',
  API_AUTH_PASSWORD_TOO_SHORT: 'Password must be at least 8 characters long.',
  API_AUTH_PASSWORD_MISMATCH: 'Passwords do not match.',
  API_AUTH_USERNAME_TAKEN: 'Username is already taken. Please choose another.',
  API_AUTH_EMAIL_TAKEN: 'This email address is already registered.',
  API_AUTH_INVALID_CREDENTIALS: 'Invalid username or password.',
  API_AUTH_ACCOUNT_NOT_VERIFIED: 'Account not verified. Please check your email for the verification link.',
  API_AUTH_TOKEN_MISSING: 'Verification or reset token is missing.',
  API_AUTH_TOKEN_INVALID_OR_EXPIRED: 'This verification or password reset link is invalid or has expired.',
  API_AUTH_PASSWORD_RESET_FAILED: 'Failed to reset password. The link may be invalid or expired, or a server error occurred.',
  API_AUTH_FORGOT_PASSWORD_SENT: 'If a user account exists with the email address you provided, a password reset link has been sent',
  API_AUTH_FORBIDDEN: "You are not athorized to perform this action",
  API_USER_NOT_FOUND: "Username not found",

  //Download Errors (Returned by Backend)
  API_DOWNLOAD_MISSING_KEY: "Required object key parameter is missing or invalid.",

  //File Errors (Returned by Backend)
  API_FILE_MISSING_KEY: "Object Key Missing, Delete Failed",
  API_FILE_DELETE_SUCCESS: "Object Successfully Deleted",
  API_INVALID_PARAMETER: "Invalid request parameter value.",
  API_UPLOAD_MISSING_FILENAMES: "File Name Missing",
  AUTH_ERROR_GENERIC_REQUEST_FAILED: "Request Failed",

  // Server Errors (Returned by Backend)
  API_SERVER_ERROR_GENERIC: 'An unexpected server error occurred. Please try again later.',

};

export default en;